<div class="stepper-container my-3" *ngIf="showSteps">
    <div class="flex justify-content-evenly mb-3">
        <p class="t-12-400-white" *ngFor="let label of stepperConfig.labels">{{ label }}</p>
    </div>
    <div class="line" [ngStyle]="{'width': stepperConfig.totalSteps === 2 ? '50%' : '70%'}">
        <img *ngFor="let step of getStepsArray(); trackBy: trackByIndex" 
             [src]="'assets/icons/stepper/' + steps['step' + step]" 
             width="18" 
             height="18" 
             alt="">
    </div>
</div>
